import React, { useEffect, useState } from 'react';

import { Button } from 'js/components/common/Button';
import { I18n } from 'js/components/common/I18n';
import { Icon } from 'js/components/common/Icon';
import { LocalPopup } from 'js/components/common/Popup';

import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';

import { useInMobile } from 'js/app/hooks/device/hooks/useMediaQuery';
import { useDynamicTags } from 'js/app/hooks/useDynamicTags';
import { useTranslations } from 'js/hooks/i18n';
import { useNavigate } from 'js/hooks/navigate';
import { componentService } from 'js/services/component.service';

import { useRemainingDepositLimits } from '../../hooks/useRemainingDepositLimits';

import style from './FundsTransferModal.scss';

export const FundsTransferModal = () => {
    const navigate = useNavigate();
    const isMobile = useInMobile();
    const [isShow, setIsShow] = useState(false);
    const t = useTranslations('playtech.mobile.system.fund-transfer.prompt.');
    const [dTagFundsTransferPageUrl = '/transfer-funds'] = useDynamicTags([DYNAMIC_TAG_NAMES.fundsTransferPageUrl]);

    const [{ data }] = useRemainingDepositLimits();

    useEffect(() => {
        setIsShow(data.shouldShowFundsTransferPrompt);
    }, [data.shouldShowFundsTransferPrompt]);

    const handlerClosePopup = () => setIsShow(false);

    if (!isShow) {
        return null;
    }

    if (isMobile) {
        return (
            <div data-testid="FundsTransferModal_mobileContainer" className={style.containerMobile}>
                <div className={style.title}>{t('mobile.title')}</div>

                <I18n className={style.text} t={t} tKey="mobile.text" replacers={[data?.clubBalance]} />

                <Button
                    data-testid="FundsTransferModal_yes-button"
                    className={style.button}
                    onClick={() => navigate(dTagFundsTransferPageUrl)}
                >
                    {t('mobile.yes-button')}
                </Button>

                <Icon
                    data-testid="FundsTransferModal_closePopup"
                    type="closePopup"
                    className={style.close}
                    onClick={handlerClosePopup}
                />
            </div>
        );
    }

    return (
        <LocalPopup
            data-testid="FundsTransferModal_container"
            title={t('title')}
            className={style.containerPopup}
            onClose={handlerClosePopup}
            buttons={[
                {
                    text: t('yes-button'),
                    className: style.btnPopupAlreadyUser,
                    onClick: () => navigate(dTagFundsTransferPageUrl)
                },
                {
                    text: t('no-button'),
                    size: 'small',
                    view: 'link',
                    onClick: handlerClosePopup
                }
            ]}
        >
            <I18n t={t} tKey="text" replacers={[data?.clubBalance, data?.allowedToTransfer.label]} />

            <div className={style.footnote}>{t('footnote')}</div>
        </LocalPopup>
    );
};

componentService.registerWebContentComponents({ FundsTransferModal });
